export enum ActionType {
    NONE = "",

    BALANCE_UPDATE_RESUME_PER_DAY = "BALANCE_UPDATE_RESUME_PER_DAY",
    BALANCE_UPDATE_HISTORIC = "BALANCE_UPDATE_HISTORIC",
    BALANCE_UPDATE = "BALANCE_UPDATE",

    UI_OPEN_DEPOSIT_ACCOUNTS = "UI_OPEN_DEPOSIT_ACCOUNTS",
    UI_CLOSE_DEPOSIT_ACCOUNTS = "UI_CLOSE_DEPOSIT_ACCOUNTS",

    UI_OPEN_COMMISSIONS = "UI_OPEN_COMMISSIONS",
    UI_CLOSE_COMMISSIONS = "UI_CLOSE_COMMISSION",

    UI_OPEN_TWOFACTOR = "UI_OPEN_TWOFACTOR",
    UI_CLOSE_TWOFACTOR = "UI_CLOSE_TWOFACTOR",

    UI_SHOW_BALANCE = "UI_SHOW_BALANCE",
    UI_HIDE_BALANCE = "UI_HIDE_BALANCE",

    UI_OPEN_PASSWORD = "UI_OPEN_PASSWORD",
    UI_CLOSE_PASSWORD = "UI_CLOSE_PASSWORD",

    UI_OPEN_SESSION_TIME = "UI_OPEN_SESSION_TIME",
    UI_CLOSE_SESSION_TIME = "UI_CLOSE_SESSION_TIME",

    UI_OPEN_MODAL_MOV = "UI_OPEN_MODAL_MOV",
    UI_CLOSE_MODAL_MOV = "UI_CLOSE_MODAL_MOV",

    UI_SET_LOGIN_CHECK_LOADING = "UI_SET_LOGIN_CHECK_LOADING",

    UI_OPEN_MODAL_HELP = "UI_OPEN_MODAL_HELP",
    UI_CLOSE_MODAL_HELP = "UI_CLOSE_MODAL_HELP",

    SALE_OPEN = "SALE_OPEN",
    SALE_CLOSE = "SALE_CLOSE",
    SALE_RESET = "SALE_RESET",
    SALE_NEXT = "SALE_NEXT",
    SALE_PREVIOUS = "SALE_PREVIOUS",
    SALE_SHOW_LOADING = "SALE_SHOW_LOADING",
    SALE_HIDE_LOADING = "SALE_HIDE_LOADING",
    SALE_SET_SKU = "SALE_SET_SKU",
    SALE_SET_SKU_DETAIL = "SALE_SET_SKU_DETAIL",
    SALE_SET_RESULT = "SALE_SET_RESULT",
    SALE_ADD_PARAMS = "SALE_ADD_PARAMS",
    SALE_SET_ELEMENTS_IN_BODY = "SALE_SET_ELEMENTS_IN_BODY",
    SALE_SET_PARAMS = "SALE_SET_PARAMS",
    SALE_RETURN_TO_OPTIONS = "SALE_RETURN_TO_OPTIONS",
    SALE_SHOW_CONFIRM = "SALE_SHOW_CONFIRM",
    SALE_SET_MODAL_STEP = "SALE_SET_MODAL_STEP",
    SALE_SHOW_TICKET_FAILED = "SALE_SHOW_TICKET_FAILED",
    SALE_HIDE_TICKET_FAILED = "SALE_HIDE_TICKET_FAILED",

    MODALMOV_OPEN = "MODALMOV_OPEN",
    MODALMOV_CLOSE = "MODALMOV_CLOSE",
    MODALMOV_SET_DATA = "MODALMOV_SET_DATA",
    MODALMOV_SET_DATA_ALL = "MODALMOV_SET_DATA_ALL",
    MODALMOV_SET_DATE = "MODALMOV_SET_DATE",
    MODALMOV_SET_DATE_END = 'MODALMOV_SET_DATE_END',
    MODALMOV_SET_PAGE = "MODALMOV_SET_PAGE",
    MODALMOV_SET_QUERYTYPE = "MODALMOV_SET_QUERYTYPE",
    MODALMOV_SET_TOKEN = "MODALMOV_SET_TOKEN",
    MODALMOV_SETUP = "MODALMOV_SETUP",
    MODALMOV_SET_CUSTOM = "MODALMOV_SET_CUSTOM",
    MODALMOV_RESET = "MODALMOV_RESET",

    //Ui Loading
    LOADING_ACTIVE = "Loading active",
    LOADING_INACTIVE = "Loading inactive",

    //PDV Info
    SET_PDV_INFO = "SET_PDV_INFO",

    //Pines Usuarios
    LIST_PINES_USUARIOS = "LISTA DE PINES USUARIOS",
    LIST_PINES_HORARIOS = "LISTA DE LOS HORARIOS DE UN PIN",

    // [Balance Step 4]: Tipo de acción para actualizar balance en el estado
    SALE_SET_CLIENT_BALANCE = 'SALE_SET_CLIENT_BALANCE',
    SALE_LOADING_BALANCE = 'SALE_LOADING_BALANCE',
    SALE_LOADING_INACTIVE_BALANCE = 'SALE_LOADING_INACTIVE_BALANCE'
}